module.exports = __webpack_public_path__ + "./kit/docs/img/react-native.30fbaf969d69333f25bd3514acc77b0b.svg";